import {useState, useEffect} from 'react';
import {Form, InputGroup, Button, ListGroup} from 'react-bootstrap';
import LabelComponent from './LabelComponent.js';


export default function SearchListComponent({label, labelIcon = <></>, placeholder, data=[], onClickBranch, activeListId}) {

  const [searchText, setSearchText] = useState("");

  useEffect(() => {

  });

  function getData() {
    return data.filter( (obj) => obj.searchText.toLowerCase().indexOf(searchText) > -1 )
  }

  function handleOnChangeSearchText(value) {
    setSearchText(value.toLowerCase());
  }

  function handleClear() {
    setSearchText("");
    onClickBranch(0);
  }

  function handleOnClickItem(id) {
    if(id === activeListId) {
      onClickBranch(0);
    } else {
      onClickBranch(id);
    }
  }

  return (
    <>
      <LabelComponent 
        label={label}
        labelIcon={labelIcon}
      />
      <InputGroup>
        <Form.Control
          placeholder={placeholder}
          aria-label={label}
          onChange={(e) => handleOnChangeSearchText(e.currentTarget.value) }
          value={searchText}
        />
        {searchText &&
        <Button variant="outline-secondary" onClick={handleClear}>Clear</Button>
        }
      </InputGroup>
      {(searchText || activeListId > 0) &&      
      <ListGroup style={{maxHeight:'200px',overflowY:'auto', position:'absolute', zIndex:'1'}}>
        {getData().map( (row, index) => {
          if(row.id) {
            return (
            <ListGroup.Item key={row.id} onClick={() => handleOnClickItem(row.id)} active={activeListId === row.id ? true: false} action>
              {row.label}
            </ListGroup.Item>);
          }
        })}
      </ListGroup>
      }
    </>
  );
}